import { apiSlice } from '../../../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({
    addTagTypes: [
      'FisheryLakes',
      'Promotions',
      'Product',
      'access',
      'member-setting',
      'membership-form',
      'membership-plan',
      'custom-slot-plan',
      'user-season-ticket',
      'PrintSettings',
      'BookingSettings',
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getLakes: builder.query({
        query: () => ({
          url: 'fishery/lakes',
        }),
      }),
      getLakeswithTypes: builder.query({
        query: (fishery_id) => ({
          url: 'fishery/assets/lake-booking-types',
          params: { fishery_id },
        }),
      }),
      getPromotions: builder.query({
        query: () => ({
          url: 'fishery/promotions',
        }),
        providesTags: ['Promotions'],
      }),
      createPromotion: builder.mutation({
        query: (data) => ({
          url: `fishery/create-promotion`,
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'Promotions' }],
      }),
      updatePromotion: builder.mutation({
        query: (data) => ({
          url: `fishery/promotion/update`,
          method: 'put',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'Promotions' }],
      }),
      deletePromotion: builder.mutation({
        query: (id) => ({
          url: `fishery/promotion`,
          method: 'delete',
          params: { id },
        }),
        invalidatesTags: (result, error) => [{ type: 'Promotions' }],
      }),
      getProducts: builder.query({
        query: () => ({
          url: 'fishery/products',
        }),
        providesTags: ['Product'],
      }),
      createProduct: builder.mutation({
        query: (data) => ({
          url: `fishery/products`,
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'Product' }],
      }),
      updateProduct: builder.mutation({
        query: (data) => ({
          url: `fishery/products/update`,
          method: 'put',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'Product' }],
      }),
      deleteProduct: builder.mutation({
        query: (product_id) => ({
          url: `fishery/products/delete`,
          method: 'delete',
          params: { product_id },
        }),
        invalidatesTags: (result, error) => [{ type: 'Product' }],
      }),
      getAccessCodes: builder.query({
        query: () => ({
          url: 'fishery/access_code/settings',
        }),
        providesTags: ['access'],
      }),
      createAccessCode: builder.mutation({
        query: (data) => ({
          url: `fishery/access_code/settings`,
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'access' }],
      }),
      updateAccessCode: builder.mutation({
        query: (data) => ({
          url: `fishery/access_code/settings`,
          method: 'put',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'access' }],
      }),
      deleteAccessCode: builder.mutation({
        query: (access_code_id) => ({
          url: `fishery/access_code/settings`,
          method: 'delete',
          params: { access_code_id },
        }),
        invalidatesTags: (result, error) => [{ type: 'access' }],
      }),
      getCustomProperty: builder.query({
        query: () => ({
          url: 'fishery/booking/properties',
        }),
        providesTags: ['custom-property'],
      }),
      createCustomProperty: builder.mutation({
        query: (data) => ({
          url: `fishery/booking/properties`,
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'custom-property' }],
      }),

      updateCustomPropertyOrder: builder.mutation({
        query: (data) => ({
          url: `fishery/booking/properties/update_order`,
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'custom-property' }],
      }),
      updateCustomProperty: builder.mutation({
        query: (data) => ({
          url: `fishery/booking/properties/update`,
          method: 'put',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'custom-property' }],
      }),
      deletecustomProperty: builder.mutation({
        query: (id) => ({
          url: `fishery/booking/properties/delete`,
          method: 'delete',
          params: { id: id },
        }),
        invalidatesTags: (result, error) => [{ type: 'custom-property' }],
      }),
      updateAsset: builder.mutation({
        query: (data) => ({
          url: `fishery/assets/update`,
          method: 'put',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'assets' }],
      }),
      deleteAsset: builder.mutation({
        query: (id) => ({
          url: `fishery/assets/delete`,
          method: 'delete',
          params: { asset_id: id },
        }),
        invalidatesTags: (result, error) => [{ type: 'assets' }],
      }),
      getAssets: builder.query({
        query: (id) => ({
          url: 'fishery/assets',
          params: { lake_id: id },
        }),
        providesTags: ['assets'],
      }),
      createAsset: builder.mutation({
        query: (data) => ({
          url: `fishery/assets`,
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'assets' }],
      }),
      updateAssetOrder: builder.mutation({
        query: (data) => ({
          url: `fishery/assets/update_order`,
          method: 'put',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'assets' }],
      }),
      getMemberSettings: builder.query({
        query: (fishery_id) => ({
          url: 'fishery/members/settings',
          params: { fishery_id },
        }),
        providesTags: ['member-setting'],
      }),
      updateMemberSettings: builder.mutation({
        query: (data) => ({
          url: `fishery/member/settings`,
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'member-setting' }],
      }),
      getMembershipForm: builder.query({
        query: (form_type) => ({
          url: 'fishery/membership/form',
          params: { form_type },
          useDefaultErrorHandler: false,
        }),
        providesTags: ['membership-form'],
      }),
      updateMembershipForm: builder.mutation({
        query: (data) => ({
          url: `fishery/membership/form`,
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [
          { type: 'membership-form' },
          { type: 'members' },
          { type: 'special-members' },
        ],
      }),
      getAllMembershipPlan: builder.query({
        query: (fishery_id) => ({
          url: 'fishery/membership_plans',
          params: { fishery_id },
          useDefaultErrorHandler: false,
        }),
        providesTags: ['membership-plan'],
      }),
      getAllCustomSlots: builder.query({
        query: (fishery_id) => ({
          url: 'booking/fishery/custom_slots',
          params: { fishery_id },
        }),
        providesTags: ['custom-slot-plan'],
      }),
      getMembershipPlan: builder.query({
        query: (plan_id) => ({
          url: 'fishery/membership/plan',
          params: { plan_id },
        }),
      }),
      deleteMembershipPlan: builder.mutation({
        query: (plan_id) => ({
          url: 'fishery/membership/plan',
          params: { plan_id },
          method: 'delete',
        }),
        invalidatesTags: (result, error) => [{ type: 'membership-form' }],
      }),
      updateMembershipPlan: builder.mutation({
        query: (data) => ({
          url: `fishery/membership/plan`,
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'membership-form' }],
      }),
      updatePlanOrder: builder.mutation({
        query: (data) => ({
          url: `fishery/membership/plan/update_order`,
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'membership-form' }],
      }),
      getSeasonTicketValidation: builder.query({
        query: (args) => ({
          url: `user/has_season_ticket?email=${encodeURIComponent(
            args.email
          )}&lake_id=${args.lake_id}`,
        }),
        providesTags: ['user-season-ticket'],
      }),
      getPrintSettings: builder.query({
        query: () => ({
          url: `fishery/settings/printer`,
        }),
        providesTags: ['PrintSettings'],
      }),
      updatePrintSettings: builder.mutation({
        query: (newSettings) => ({
          url: `fishery/settings/printer`,
          data: newSettings,
          method: 'PUT',
        }),
        invalidatesTags: (result, error) => ['PrintSettings'],
      }),
      getBookingSettings: builder.query({
        query: () => ({
          url: 'fishery/booking/settings',
        }),
        providesTags: ['BookingSettings'],
      }),
      updateBookingSettings: builder.mutation({
        query: (newSettings) => ({
          url: `fishery/booking/settings`,
          data: newSettings,
          method: 'POST',
        }),
        invalidatesTags: (result, error) => ['BookingSettings'],
      }),
    }),
  });

export const {
  useGetLakesQuery,
  useGetPromotionsQuery,
  useGetAllCustomSlotsQuery,
  useCreatePromotionMutation,
  useUpdatePromotionMutation,
  useDeletePromotionMutation,
  useGetProductsQuery,
  useCreateProductMutation,
  useDeleteProductMutation,
  useUpdateProductMutation,
  useGetMemberSettingsQuery,
  useUpdateMemberSettingsMutation,
  useGetAccessCodesQuery,
  useCreateAccessCodeMutation,
  useDeleteAccessCodeMutation,
  useUpdateAccessCodeMutation,
  useGetSeasonTicketValidationQuery,
  useGetMembershipFormQuery,
  useUpdateMembershipFormMutation,
  useGetAllMembershipPlanQuery,
  useGetMembershipPlanQuery,
  useDeleteMembershipPlanMutation,
  useUpdateMembershipPlanMutation,
  useUpdatePlanOrderMutation,
  useGetPrintSettingsQuery,
  useUpdatePrintSettingsMutation,
  useGetBookingSettingsQuery,
  useUpdateBookingSettingsMutation,
  useGetCustomPropertyQuery,
  useUpdateCustomPropertyMutation,
  useUpdateCustomPropertyOrderMutation,
  useCreateCustomPropertyMutation,
  useDeletecustomPropertyMutation,
  useGetAssetsQuery,
  useCreateAssetMutation,
  useUpdateAssetMutation,
  useDeleteAssetMutation,
  useGetLakeswithTypesQuery,
  useUpdateAssetOrderMutation,
} = extendedApiSlice;
